<template>
  <div class="logo">
    <img alt="alt_text" aria-hidden="true" border="0" height="100" @error="useDefaultImage" :src="imgUrl" width="100">
    <h1 id="title" :style="{ 'color': primaryColor }">{{ title }}</h1>
  </div>
</template>

<script>
  import main from './Logo.js'
  export default main
</script>

<style lang="scss" scoped>
  @import '../variable.scss';
  @import './Logo.scss';
</style>



// WEBPACK FOOTER //
// Logo.vue?69430c61